<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hyp3DI/tc-custom/9781783469697.jpg?1734550472185" alt="This image is the cover for the book Grand Fleet Battlecruisers, ShipCraft"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Grand Fleet Battlecruisers, ShipCraft
      </h1>
      <p class="bookDescription body article font2">
        <p>The ShipCraft series provides in-depth information about building and modifying model kits of famous warship types. Lavishly illustrated, each book takes the modeller through a brief history of the subject class, highlighting differences between sister-ships and changes in their appearance over their careers. This includes paint schemes and camouflage, featuring colour profiles and highly-detailed line drawings and scale plans. The modelling section reviews the strengths and weaknesses of available kits, lists commercial accessory sets for super-detailing of the ships, and provides hints on modifying and improving the basic kit. This is followed by an extensive photographic gallery of selected high-quality models in a variety of scales, and the book concludes with a section on research references  books, monographs, large-scale plans and relevant websites.rnrnThis volume follows the format of the highly successful Flower Class where the extent has been doubled to include far more illustrations of the many different designs, from the Invincible of 1906 to the Renowns of 1915, and including the hybrid large light cruisers Courageous, Glorious and Furious.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Steve Backer
      </h2>
      
      <p class="authorDescription body article">Steve Backer is the editor of steelnavy.com, the best warship modeling site on the web, for which he writes extensively on warship kits and accessories. He is also the author of five previous titles in this ShipCraft series, the most recent being Admiral Hipper Class Cruisers.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Seaforth Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?98806cb6